import React, {useEffect} from 'react';
import {BaseModal} from "./modalStyle";
import styled, {css} from "styled-components";
import ExitButton from "../buttons/ExitButton";
import {useDispatch, useSelector} from "react-redux";
import {CLEAR_USER} from "../user/userTypes";
import AddUserModal from "./AddUserModal";
import EditUserModal from "./EditUserModal";
import {displayAlert} from "../../utils/utils";


const UserModal = ({
                       setModalIsOpen,
                       isEditAction = false,
                       isCurrentUser = false
                   }) => {

    const dispatch = useDispatch()
    const {status} = useSelector(state => state.oneUser)

    useEffect(() => {
        return () => {
            dispatch({
                type: CLEAR_USER
            })
        }
    }, [dispatch])


    const closeModal = () => {
        setModalIsOpen(false)
    }


    return (
        <Div $mode={isCurrentUser}>
            {displayAlert(status !== 0 && (status.toString().startsWith("4") || status.toString().startsWith("5")), status.toString().startsWith("2"))}
            <Modal>
                <FirstSection className={'flex-row '}>
                    <h1>{isEditAction ? "Modifier le profil " : "Créer un nouvel utilisateur"}</h1>
                    <ExitButton closeUpdate={closeModal}/>
                </FirstSection>
                {!isEditAction &&
                <AddUserModal
                    isCurrentUser={isCurrentUser}
                    setModalIsOpen={setModalIsOpen}
                />
                }
                {isEditAction &&
                <EditUserModal
                    isCurrentUser={isCurrentUser}
                    setModalIsOpen={setModalIsOpen}
                />
                }
            </Modal>
        </Div>
    )
}


const Div = styled.div`

  ${(props) => {
    switch (props.$mode) {
      case false:
        return css`
          width: 100%;
          overflow-y: auto;
          overflow-x: hidden;
          background: rgba(0, 0, 0, 0.5);
          position: fixed;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 1;
        `;

      default:
        return css`
        `;
    }
  }}
`
const Modal = styled(BaseModal)`
  flex-direction: column;
  align-items: center;
  gap: 1em;
  height: fit-content;
  @media (min-width: 600px) {
    min-width: 600px;
    max-width: 600px;
    width: 600px;
    height: fit-content;
  }
`

const FirstSection = styled.div`
  width: 100%;

  h1 {
    flex-grow: 1;
    text-align: center;
  }

  button {
    transform: translate(10%, -50%);
  }
`


export default UserModal;